<template>
  <div class="flex flex-col gap-2">
    <label
      :for="id"
      class="block text-sm font-medium text-primary"
      :class="{ 'required-label': required }"
      >{{ label }}
    </label>
    <div
      class="flex justify-center items-center gap-2 border-b-[1px] border-dark4 focus-within:border-primary [&:has(input:disabled)]:bg-dark4 [&:has(input:disabled)]:bg-opacity-5"
    >
      <slot name="prefix"></slot>
      <input
        :id="id"
        v-model.trim="model"
        :data-testId="name"
        :type="type"
        :name="name"
        :disabled="disabled"
        class="h-10 w-full text-white placeholder-dark4 focus:outline-none bg-transparent disabled:cursor-not-allowed"
        :placeholder="placeholder"
      />
      <slot name="postfix"></slot>
    </div>
    <span v-if="error" class="text-red-400">{{ error }}</span>
  </div>
</template>

<script setup lang="ts">
  interface Props {
    id: string;
    type?: string;
    name: string;
    label: string;
    placeholder?: string;
    required?: boolean;
    error?: string;
    disabled?: boolean;
  }

  withDefaults(defineProps<Props>(), {
    type: 'text',
    placeholder: '',
    required: false,
    disabled: false,
    error: ''
  });

  const model = defineModel<string | number>();
</script>

<style lang="scss" scoped>
  .required-label::after {
    content: '*';
    margin-left: 0.25rem;
    color: theme('colors.primary');
  }
</style>
